import { useState } from "react";
import { Link } from "react-router-dom";


export default function FaqFour({
  faqs = [],
  pillName = "FAQs",
  heading = "Frequently Asked Questions & Answer"
}) {
  const [activeFAQ, setActiveFAQ] = useState(0);

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? 0 : index);
  };

  return (
    <section id="faq" className="pt-16 mb-16 md:pb-[153px]">
      <div className="theme-container mx-auto px-4 grid grid-cols-6 lg:grid-cols-12 sm:gap-[63px]">
        <div className="col-span-6">
          <h1 className="border text-chip border-purple/30 py-0.5 px-5 rounded-[30px] w-fit mb-5 text-sm sm:text-base">
            {pillName}
          </h1>

          <h2 className="mt-5 font-semibold text-34 sm:text-34 md:text-48 text-white">
            {heading}
          </h2>
          <p className="text-paragraph mt-6 sm:mt-[30px] max-w-[424px] mb-4 sm:mb-[18px] text-sm sm:text-base">
            We've answered a few common ones to help you understand how we work
            and what you can expect.
          </p>
          <Link to="/contact" className="home-two-btn-bg py-2.5 sm:py-3.5 group h4_contact_bg border-transparent w-fit mt-2.5 inline-flex items-center gap-2">
            <span className="relative z-10 text-sm sm:text-base font-semibold text-white transition-all duration-300 group-hover:text-purple font-inter">
              Chat with Us
            </span>
            <svg
              className="relative z-10"
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className="transition-all duration-300 group-hover:stroke-purple"
                d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
        <div className="col-span-6 mt-5 md:mt-0">
          <div data-aos="fade-up" className="flex flex-col gap-2.5 w-full">
            {/* <!-- faq single start  --> */}
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`py-4 sm:py-5 px-3 sm:px-2 md:px-[30px] w-full rounded-[10px] h7-faq-toggler overflow-hidden transition-all duration-300 max-h-fit h-fit border border-blue-seo/15 ${
                  activeFAQ === index ? "text-blue-seo  bg-blue-seo/10 " : ""
                }`}
                name="faq-1"
                onClick={() => toggleFAQ(index)}
              >
                <div className="flex items-center justify-between w-full pointer-events-none h-fit">
                  <h1
                    className={`font-semibold text-16 sm:text-18 text-blue-seo ${
                      activeFAQ === index ? "text-chip" : "text-white"
                    }`}
                  >
                    {faq.question}
                  </h1>

                  <svg
                    style={{
                      rotate: activeFAQ === index ? "180deg" : "0deg",
                      transition: "rotate 0.3s ease",
                    }}
                    width="19"
                    height="10"
                    viewBox="0 0 19 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 2L9.5 8L17 2"
                      stroke="#3674FB"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                {activeFAQ === index && (
                  <p className="mt-3.5 text-paragraph pointer-events-none h-fit text-sm sm:text-base">
                    {faq.answer}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
